import { render } from "./UserManualSettings.vue?vue&type=template&id=6399a27c&scoped=true"
import script from "./UserManualSettings.vue?vue&type=script&lang=js"
export * from "./UserManualSettings.vue?vue&type=script&lang=js"

import "./UserManualSettings.vue?vue&type=style&index=0&id=6399a27c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6399a27c"]])

export default __exports__